import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



export default function JobMetrics({job}) {
    job.sort((a, b) => new Date(b.dateOfFinancialStatement) - new Date(a.dateOfFinancialStatement));

// Get the two latest formattedValue values
const latestFormattedValues = job.slice(0, 2).map(item => item);

console.log(latestFormattedValues);
    function createData(name, twotwo, twoone) {
        return { name, twotwo, twoone };
    }
    
    const rows = [
        createData('Net worth + available loc', latestFormattedValues[0]?.netWorthTotalLineCredit, latestFormattedValues[1]?.netWorthTotalLineCredit),
        createData('Five (5) times working capital', latestFormattedValues[0]?.fivetimesWorkingCapital, latestFormattedValues[1]?.fivetimesWorkingCapital),
        createData('25% of prior year’s revenue', latestFormattedValues[0]?.twntyFivePrcntPriorYearRevenue, latestFormattedValues[1]?.twntyFivePrcntPriorYearRevenue),
        createData('70% of 3 largest completed contracts', latestFormattedValues[0]?.seventyFivePercentLargestCompletedProject, latestFormattedValues[1]?.seventyFivePercentLargestCompletedProject),
        createData('Average of these measures for single job', latestFormattedValues[0]?.avrgMeasuresForSingleJob, latestFormattedValues[1]?.avrgMeasuresForSingleJob),
    ];
    
    const rows1 = [
        createData('Net worth + total line of credit', latestFormattedValues[0]?.netWorthTotalLineCredit, latestFormattedValues[1]?.netWorthTotalLineCredit),
        createData('Ten (10) times working capital',  latestFormattedValues[0]?.tenTimesWorkingCapital, latestFormattedValues[1]?.tenTimesWorkingCapital),
        createData('50% of prior year’s revenue',  latestFormattedValues[0]?.fiftyPercentPriorYearRevenue, latestFormattedValues[1]?.fiftyPercentPriorYearRevenue),
        createData('Ten (10) times net worth',  latestFormattedValues[0]?.tenTimesNetWorth, latestFormattedValues[1]?.tenTimesNetWorth),
        createData('Average of these measures for aggregate',  latestFormattedValues[0]?.avrgMeasuresForAggrigate, latestFormattedValues[1]?.avrgMeasuresForAggrigate),
    
    ];
    
    const rows2 = [
        createData('Total line of credit',  latestFormattedValues[0]?.totalLinesCredit, latestFormattedValues[1]?.totalLinesCredit),
        createData('Available line of credit', latestFormattedValues[0]?.availableLineCredit, latestFormattedValues[1]?.availableLineCredit),
        createData('Total of 3 largest completed projects',  latestFormattedValues[0]?.totalOfThreeLargestCompletedProjects, latestFormattedValues[1]?.totalOfThreeLargestCompletedProjects),
    ];
    return (
        <>
            <Box
                sx={{

                    backgroundColor: 'white',
                }}
            >
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                                <StyledTableCell align="center" className='text-muted'>{latestFormattedValues[0]?.formattedValue}</StyledTableCell>
                                <StyledTableCell align="right" className='text-muted'>{latestFormattedValues[1]?.formattedValue}</StyledTableCell>

                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>Single Job Recommendation</StyledTableCell>
                                <StyledTableCell className='text-muted'>&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>&nbsp;</StyledTableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.name}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" >{row.twotwo}</StyledTableCell>
                                    <StyledTableCell align="right" >{row.twoone}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>Aggregate Backlog</StyledTableCell>
                                <StyledTableCell className='text-muted'>&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows1.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.name}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" >{row.twotwo}</StyledTableCell>
                                    <StyledTableCell align="right" >{row.twoone}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>Other Information Needed For This Analysis</StyledTableCell>
                                <StyledTableCell className='text-muted'>&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows2.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.name}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" >{row.twotwo}</StyledTableCell>
                                    <StyledTableCell align="right" >{row.twoone}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}